/**
 * AJAX to fetch categories and products for the “Find Your Product”
 * area of the Resources section.
 */
$(document).ready(function() {

	var ajaxGetChildren = function(e) {
		e.preventDefault();

		// Unbind these events, or stack bindings on each interaction
		$('.ajax-get-children-select').unbind('change');
		$('.ajax-get-children-list a').unbind('click');

		// Check whether the user has chosen a division and, depending
		// on choice, hide relevant content to “reset” to the most recent click.
		if ( e.currentTarget.getAttribute('data-division') ) {
			$('.product-selector-columns .product-selector-column').remove();
			$('.division-selector-item a').removeClass('active');
			$(this).addClass('active');
		} else {
			$(this).parents('.product-selector-column').nextAll().remove();
			$(this).parents('.product-selector-list').find('a').removeClass('active');
			$(this).addClass('active');
		}

		// AJAX call to go and fetch requested content
		$.post(
		    ajax_obj.ajax_url,
		    {
		        'action': 'get_child_terms',
		        'id': e.currentTarget.value ? e.currentTarget.value : e.currentTarget.getAttribute('data-id'),
		        'target': e.currentTarget.getAttribute('data-target')
		    },
		    function(response) {
		    	// Append response to the DOM and re-bind required events
		    	$('.product-selector-columns .product-selector-grid').append('<div class="product-selector-column"></div>');
		        $('.product-selector-column').last().append(response);
		        $('.ajax-get-children-select').on('change', ajaxGetChildren);
		        $('.ajax-get-children-list a').on('click', ajaxGetChildren);
		    }
		);
	}

	// Bind events for the first time on document ready
	$('.ajax-get-children-select').on('change', ajaxGetChildren);
	$('.ajax-get-children-list a').on('click', ajaxGetChildren);

});